import { render } from "./HelpInfo.vue?vue&type=template&id=28aed04c"
import script from "./HelpInfo.vue?vue&type=script&lang=js"
export * from "./HelpInfo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Proyectos\\Crypto\\dex\\github\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__